/* global google */
/* eslint no-unused-vars: ['error', { 'varsIgnorePattern': 'map' }] */

import SnazzyInfoWindow from 'snazzy-info-window';
import mapStyles from '../../plugins/map-styles';

export default () => {

  const mapContainer = $('.community-map-container');

  const community = {
    latitude: $('.community-map-container').data('latitude'),
    longitude: $('.community-map-container').data('longitude'),
    title: $('.community-map-container').data('title'),
    street: $('.community-map-container').data('street'),
    city: $('.community-map-container').data('city'),
    state: $('.community-map-container').data('state'),
    zip: $('.community-map-container').data('zip')
  };

  const directionsURL = encodeURIComponent(community.title + ' ' + community.street + ' ' + community.city + ', ' + community.state + ' ' + community.zip);

  // Coordinates of the community
  const communityLocation = new google.maps.LatLng(community.latitude, community.longitude);

  // Instantiate map with mapOptions
  const map = new google.maps.Map(mapContainer[0], {
    center: communityLocation,
    zoom: 15,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    gestureHandling: 'cooperative',
    scrollwheel: false,
    styles: mapStyles
  });

  // Draw a marker for each random point
  const marker = new google.maps.Marker({
    map,
    position: communityLocation,
    icon: {
      url: '/assets/images/map-marker.svg',
      anchor: new google.maps.Point(16, 40),
      scaledSize: new google.maps.Size(32, 40),
      origin: new google.maps.Point(0, 0)
    },
    draggable: false,
    optimized: false
  });

  // define our infowindows
  new SnazzyInfoWindow({
    marker,
    map,
    closeOnMapClick: false,
    shadow: false,
    pointer: false,
    border: false,
    position: communityLocation,
    offset: {
      top: '-64px',
      left: '0'
    },
    edgeOffset: {
      top: 50,
      right: 10,
      bottom: 25,
      left: 10
    },
    panOnOpen: true,
    content: `
      <div class="find-community-map-infowindow">
        <h5 class="find-community-map-infowindow-title">${community.title}</h5>
        <div class="find-community-map-infowindow-address">
          <div class="find-community-map-infowindow-address-line">${community.street}</div>
          <div class="find-community-map-infowindow-address-line">${community.city}, ${community.state} ${community.zip}</div>
        </div>
        <a class="find-community-map-infowindow-link" href="https://www.google.com/maps/dir/?api=1&destination=${directionsURL}" target="_blank">Get Directions</a>
      </div>
    `
  }).open();

  // set the content of our infowindows with what we stored
  // infoWindow.open();

  // Custom Zoom Controls
  const zoomControlDiv = document.createElement('div');
  zoomControlDiv.className = 'find-community-map-zoom-controls';
  new ZoomControl(zoomControlDiv, map);
  zoomControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv);

  // center map on resize
  google.maps.event.addListener(window, 'resize', () => {
    const mapCenter = map.getCenter();
    google.maps.event.trigger(map, 'resize');
    map.setCenter(mapCenter);
  });

  // Custom zoom controls
  function ZoomControl(controlDiv, map) {

    // Create control wrapper
    const controlWrapper = document.createElement('div');
    controlWrapper.className = 'find-community-map-zoom-controls-inner';
    controlDiv.appendChild(controlWrapper);

    // Create zoomIn button
    const zoomInButton = document.createElement('a');
    zoomInButton.className = 'find-community-map-zoom-controls-zoom-in';
    zoomInButton.href = '#';
    zoomInButton.textContent = '+';
    controlWrapper.appendChild(zoomInButton);

    // Create zoomOut button
    const zoomOutButton = document.createElement('a');
    zoomOutButton.className = 'find-community-map-zoom-controls-zoom-out';
    zoomOutButton.href = '#';
    zoomOutButton.textContent = '-';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    google.maps.event.addListener(zoomInButton, 'click', (e) => {
      e.preventDefault();
      $(e.currentTarget).trigger('blur');
      map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    google.maps.event.addListener(zoomOutButton, 'click', (e) => {
      e.preventDefault();
      $(e.currentTarget).trigger('blur');
      map.setZoom(map.getZoom() - 1);
    });

  }

};
